import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})

export class AttendanceService {
  constructor(private http: HttpClient) { }

  checkIn(payload: any): Observable<any> {
    return this.http.post(`${environment.Server_URL}/attendance/check-in`, payload);
  }

  checkOut(payload: any): Observable<any> {
    return this.http.post(`${environment.Server_URL}/attendance/check-out`, payload);
  }
  getTodayCheckinStatus(): Observable<any> {
    return this.http.get(`${environment.Server_URL}/attendance/status`);
  }
  getMonthlyAttendance(userId: number, month: string, year: string): Observable<any> {
    const params = new HttpParams()
      .set('user_id', userId.toString())
      .set('month', month)
      .set('year', year);

    return this.http.get(`${environment.Server_URL}/attendance/monthly`, { params });
  }

  // 🟢 إنشاء QR جديد
  generateQr(payload: { warehouse_id: any; type: 'check_in' | 'check_out' }): Observable<any> {
    return this.http.post(`${environment.Server_URL}/qr-tokens/generate`, payload);
  }

  // 🟢 جلب كل QR
  getAllQrTokens(warehouseId: any): Observable<any> {
    return this.http.get(`${environment.Server_URL}/qr-tokens?warehouse_id=${warehouseId}`);
  }


  // 🟢 التحقق من QR
  validateQr(payload: { token: string , warehouse_id: any }): Observable<any> {
    return this.http.post(`${environment.Server_URL}/qr-tokens/validate`, payload);
  }


  // 🔴 حذف QR
  deleteQr(id: number): Observable<any> {
    return this.http.delete(`${environment.Server_URL}/qr-tokens/${id}`);
  }
}
